import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Справочник содержит информацию о контейнерах.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Длина, ширина, высота (мм) - размеры контейнера"),
  /*#__PURE__*/_createElementVNode("li", null, "Вес порожнего ТС (кг) – вес пустого контейнера"),
  /*#__PURE__*/_createElementVNode("li", null, " Грузоподъемность (кг) – максимальная грузоподъемность контейнера "),
  /*#__PURE__*/_createElementVNode("li", null, " Высота ЦТ порожнего ТС (мм) – высота центра тяжести пустого контейнера относительно нулевой отметки "),
  /*#__PURE__*/_createElementVNode("li", null, " Допускаемое смещение общего груза ЦТ груза в транспорте – параметры для задания допустимых продольных и поперечных смещений центра тяжести грузов в контейнере (см. справочник Допускаемое смещение общего ЦТ груза в транспорте) "),
  /*#__PURE__*/_createElementVNode("li", null, " Отступы – параметры для задания отступов от стен контейнера (см. справочник Отступы) ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Контейнеры",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}